import { DialogTrigger, Dialog, Modal } from 'react-aria-components';
import { useForm } from 'react-hook-form';

import RadioGroup from 'src/components/RadioGroup/RadioGroup';

import Button from '@/components/Button/Button';
import InputText from '@/components/InputText/InputText';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  afterSubmit: () => void;
};

type SearchInput = {
  recipientCertificateEndDateFrom?: string;
  recipientCertificateEndDateTo?: string;
  supportEndDateFrom?: string;
  supportEndDateTo?: string;
  hasUpperManagement?: boolean;
  schoolGrade?: string;
  schoolName?: string;
  city?: string;
};

export const FilterDialog = ({ isOpen, setIsOpen, afterSubmit }: Props) => {
  const { register, handleSubmit } = useForm<SearchInput>();

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(false)}
    >
      <Modal className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <Dialog className="w-[600px] rounded-lg border border-gray-400 bg-white p-6 shadow-lg outline-none">
          <span className="flex flex-col">受給者証期限</span>
          <div className="flex flex-row gap-4">
            <InputText
              type="date"
              required={false}
              {...register('recipientCertificateEndDateFrom')}
            />
            <InputText
              type="date"
              required={false}
              {...register('recipientCertificateEndDateTo')}
            />
          </div>
          <span className="flex flex-col">支援計画期限</span>
          <div className="flex flex-row gap-4">
            <InputText
              type="date"
              required={false}
              {...register('supportEndDateFrom')}
            />
            <InputText
              type="date"
              required={false}
              {...register('supportEndDateTo')}
            />
          </div>
          <span className="flex">上限管理</span>
          <div className="flex flex-row gap-4">
            <RadioGroup
              title=""
              required={false}
              options={[
                {
                  id: 'true',
                  label: '有',
                  value: 'true',
                },
                {
                  id: 'false',
                  label: '無',
                  value: 'false',
                },
              ]}
              {...register('hasUpperManagement')}
            />
          </div>
          <div className="flex flex-row gap-4">
            <div className="flex flex-col">
              <span className="flex">学年</span>
              <InputText
                type="text"
                required={false}
                {...register('schoolGrade')}
              />
            </div>
            <div />
            <div className="flex flex-col">
              <span className="flex">学校名</span>
              <InputText
                type="text"
                required={false}
                {...register('schoolName')}
              />
            </div>
          </div>
          <span className="flex flex-col">市区町村</span>
          <InputText
            type="text"
            required={false}
            {...register('city')}
          />
          <div className="mt-4 flex flex-col justify-end gap-4">
            <Button
              type="submit"
              variant="solid-fill"
              size="lg"
              onClick={handleSubmit(afterSubmit)}
            >
              決定
            </Button>
            <button onClick={() => setIsOpen(false)}>閉じる</button>
          </div>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
